// Shared list used by Cash/Wakala UI + Wakala reports (keep values stable for filtering/history)

export const WAKALA_CHANNELS = [
  { value: 'cash', label: 'Cash (physical)' },
  { value: 'mpesa', label: 'M-Pesa (Vodacom)' },
  { value: 'tigopesa', label: 'Tigo Pesa' },
  { value: 'airtelmoney', label: 'Airtel Money' },
  { value: 'halopesa', label: 'HaloPesa (Halotel)' },
  { value: 'ttclmoney', label: 'TTCL Mobile Money' },
  { value: 'zantelmoney', label: 'Zantel EzyPesa' },
  { value: 'mixx', label: 'Mixx by Yas' },
  { value: 'crdbwakala', label: 'CRDB Bank (Wakala / agent banking)' },
  { value: 'nmbwakala', label: 'NMB Bank (Wakala / agent banking)' },
  { value: 'nbcwakala', label: 'NBC Bank (Wakala / agent banking)' },
  { value: 'equitywakala', label: 'Equity Bank (Wakala / agent banking)' },
  { value: 'azampesa', label: 'AzamPesa' },
  { value: 'card', label: 'Card / POS terminal' },
  { value: 'other', label: 'Other' },
];

/** Mitandao ya pesa kwa simu — Tanzania (malipo, usajili, n.k.) */
const TZ_MOBILE_NETWORK_VALUES = [
  'mpesa',
  'mixx',
  'tigopesa',
  'airtelmoney',
  'halopesa',
  'ttclmoney',
  'zantelmoney',
  'azampesa',
];

export const TZ_MOBILE_NETWORKS = TZ_MOBILE_NETWORK_VALUES.map((value) =>
  WAKALA_CHANNELS.find((c) => c.value === value)
).filter(Boolean);

/** formLabel = short text on New transaction form; label = full text elsewhere */
export const WAKALA_SERVICES = [
  {
    value: 'mpesa-deposit',
    label: 'Send money',
    formLabel: 'Send money',
    flow: 'in',
  },
  { value: 'airtime', label: 'Airtime / bundles', formLabel: 'Airtime / bundles', flow: 'in' },
  { value: 'billpay', label: 'Bill payment', formLabel: 'Bill payment', flow: 'in' },
  { value: 'float-topup', label: 'Float top-up (capital)', formLabel: 'Float top-up', flow: 'in' },
  { value: 'banking', label: 'Bank / other', formLabel: 'Bank / other', flow: 'in' },
  { value: 'other-services', label: 'Other services (cards, reports, etc.)', formLabel: 'Other services', flow: 'in' },
  {
    value: 'withdrawal',
    label: 'Cash out (withdrawal)',
    formLabel: 'Cash out (withdrawal)',
    flow: 'out',
  },
  {
    value: 'withdraw-agent',
    label: 'Cash out (agent number)',
    formLabel: 'Cash out (agent number)',
    flow: 'out',
  },
  {
    value: 'withdraw-lipa',
    label: 'Cash out (Lipa number)',
    formLabel: 'Cash out (Lipa number)',
    flow: 'out',
  },
];

/** Cash out: customer withdraws cash from wallet/line. */
const CASH_OUT_FORM_ORDER = ['withdrawal'];

/** Cash in: customer gives agent cash (deposits + counter services) + float top-up. */
/** Other services sales use POS → Other Services (separate ledger); not posted here. */
const CASH_IN_FORM_ORDER = ['mpesa-deposit', 'airtime', 'billpay', 'banking', 'float-topup'];

/** Legacy `service` strings (filters + labels only; not offered on New transaction). */
const LEGACY_SERVICE_LABELS = {
  'mpesa-withdraw': 'Withdrawal',
  'mpesa-withdraw-lipa': 'Withdrawal',
  'withdraw-agent': 'Cash out (agent number)',
  'withdraw-lipa': 'Cash out (Lipa number)',
  'cash-drawer-out': 'Dro withdrawal',
  'cash-out-other': 'Other withdrawal',
};

const LEGACY_FILTER_SERVICES = [
  { value: 'mpesa-lipa-in', label: 'Send money (legacy · Lipa)', formLabel: 'Send money (legacy · Lipa)', flow: 'in' },
  { value: 'withdraw-agent', label: 'Cash out (legacy · agent)', formLabel: 'Cash out (legacy · agent)', flow: 'out' },
  { value: 'withdraw-lipa', label: 'Cash out (legacy · Lipa)', formLabel: 'Cash out (legacy · Lipa)', flow: 'out' },
  { value: 'mpesa-withdraw', label: 'Withdrawal (legacy · agent)', formLabel: 'Withdrawal (legacy · agent)', flow: 'out' },
  { value: 'mpesa-withdraw-lipa', label: 'Withdrawal (legacy · Lipa)', formLabel: 'Withdrawal (legacy · Lipa)', flow: 'out' },
];

/** All services including legacy values (for history / report filters). */
export const WAKALA_SERVICES_ALL = [...WAKALA_SERVICES, ...LEGACY_FILTER_SERVICES];

/** Services shown for the New transaction form for a given direction */
export function servicesForCashDirection(direction) {
  if (direction === 'out') {
    return CASH_OUT_FORM_ORDER.map((v) => WAKALA_SERVICES.find((s) => s.value === v)).filter(Boolean);
  }
  return CASH_IN_FORM_ORDER.map((v) => WAKALA_SERVICES.find((s) => s.value === v)).filter(Boolean);
}

export function channelLabel(value) {
  if (value === 'other-services') {
    return 'Other services sales (non-wakala)';
  }
  return WAKALA_CHANNELS.find((c) => c.value === value)?.label || value || '—';
}

/** Non-wakala sales (wedding cards, etc.) — exclude from agent-network charts & wakala reports. */
export function isOtherServicesTransaction(t) {
  if (!t) return false;
  return String(t.service || '') === 'other-services';
}

/** Rows used for M-Pesa / agent “by network” views (same ledger, filtered). */
export function wakalaCashbookRows(transactions) {
  return (transactions || []).filter((t) => !isOtherServicesTransaction(t));
}

export function serviceLabel(value) {
  if (LEGACY_SERVICE_LABELS[value]) return LEGACY_SERVICE_LABELS[value];
  return WAKALA_SERVICES.find((s) => s.value === value)?.label || value || '—';
}

export function serviceFormLabel(value) {
  if (LEGACY_SERVICE_LABELS[value]) return LEGACY_SERVICE_LABELS[value];
  const s = WAKALA_SERVICES.find((x) => x.value === value);
  return s?.formLabel || s?.label || value || '—';
}
